module.exports = __webpack_public_path__ + "img/2013-4.6fea18f7.jpg";